import Vuex from 'vuex'
import Vue from 'vue'

var passwordHash = require('password-hash');
// var CryptoJS = require("crypto-js");

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
		password: 'sha1$6962618b$1$8011bf6a04a0ac2f66e190eb916b4f9294c5d12a',
		user_password: '', 
		// mr:'U2FsdGVkX1/KEL2aD3/mqQRlVOxVaFtQphtUAIAPows2s8Du5QKKAIn+h+NskB+2CXqMctKVLY1UkRqJ893kTpX5uYEQKtxMuDtW6ZklAoI=',
		mr_public:'https://microreact.org/project/hS64ttLdfxxAw2uuKzTfmQ/bc7e62a0',
		n_denmark_public:'https://nextstrain.org/groups/neherlab/ncov/denmark?c=clade_membership&d=map,tree&f_country=Denmark&p=grid&r=division',
		n_mink_public:'https://nextstrain.org/groups/neherlab/ncov/mink?p=grid',
		sk:'ZXQnVro91EowsNKvzIbs'
	},
	mutations:{
		set_password(state, payload){
			state.user_password = payload
		}
	},
	getters: {
		is_logged_in(state){
			return passwordHash.verify(state.user_password, state.password)
		},
		n_denmark_url(state){
			return state.n_denmark_public
		},
		n_mink_url(state){
			return state.n_mink_public
		},
		mr_url(state){
			return state.mr_public

			// if (getters.is_logged_in){
			// 	let bytes = CryptoJS.AES.decrypt(state.mr, state.sk)
			// 	return bytes.toString(CryptoJS.enc.Utf8)
			// }
			// return ''

			// let bytes = CryptoJS.AES.decrypt(state.mr, state.sk)
			// return bytes.toString(CryptoJS.enc.Utf8)
		}
	}
});